import type { OrgPresentationMode } from "../_shared/_logic/presentation-mode"

export type OrgPresentationPageId = "profile" | "assist" | "business" | "privacy" | "contactMethods"

type ShouldShowChatBubbleInput = {
  currentPage: OrgPresentationPageId
  presentationMode: OrgPresentationMode
  hasWidgetConfig: boolean
}

export const shouldShowOrgPresentationChatBubble = (input: ShouldShowChatBubbleInput): boolean => {
  if (!input.hasWidgetConfig) return false

  if (input.presentationMode === "appointment_portal_only") return false

  return input.currentPage !== "assist"
}
